<template>
  <div style="background-color: white;padding: 10px;margin-left: 10px;border-radius: 8px;height: calc(100vh - 82px);overflow-y: hidden">
    <div>
      <el-select v-model="build" size="small" style='width: 200px;' filterable placeholder="请选择栋舍" clearable @change="buildSelect">
        <el-option
          v-for="item in buildList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="apartment" size="small" style='width: 200px;margin-left: 10px;' filterable placeholder="请选择单元">
        <el-option
          v-for="item in apartmentList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-input v-model="input" size="small" style='width: 200px;margin-left: 10px;' placeholder="请输入序列号"></el-input>
      <el-button type="primary" size="small" style='margin-left: 10px' @click='getFodderList()'>查询</el-button>
      <el-button type="primary" size="small" style='margin-left: 10px' @click='reset()'>重置</el-button>
      <el-button type="primary" size="small" style='margin-left: 10px' @click='syncData()'>同步数据</el-button>
    </div>
    <div class='bottom'>
      <el-table
        :data="tableData"
        class='table'
        style="width: 100%">
        <el-table-column label="序列号" prop="sn"></el-table-column>
        <el-table-column label="料塔名称" prop="name"></el-table-column>
        <el-table-column label="栋舍" prop="buildName"></el-table-column>
        <el-table-column label="单元" prop="unitName"></el-table-column>
        <el-table-column label="实时重量(kg)" width='120' prop="stableValue"></el-table-column>
<!--        <el-table-column label="备注" prop="remark"></el-table-column>-->
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span style='color: red;' v-if='scope.row.isOnline === "0"'>离线</span>
            <span style='color: green;' v-else>在线</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="handleEdit(scope.$index, scope.row)">调试</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right;margin-top: 8px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, prev, pager, next, sizes"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog
      title="实时重量上报散点图"
      :visible.sync="dialogVisible"
      :before-close='clearDialog'
      width="90%">
      <div class='datePicker'>
        <el-date-picker
          v-model="time"
          @change='selectTime'
          type="daterange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-button v-if='startTime !== endTime && !isTime' type="primary" style='margin-left: 10px' @click='backToday()'>回到今天</el-button>
      </div>
<!--      <v-chart v-if='dialogVisible' @click='splashesClick($event)' :options='options' style=' width: 100%;height:380px'/>-->
      <div v-if='isTime' style='margin-bottom: 10px'>
          <span style='font-weight: bold'>{{ startTime2 }} ~ {{ endTime2.substring(11) }}</span>
            &nbsp;&nbsp;&nbsp;
          <el-button @click="getFindTowerData()" type="text">返回</el-button>
      </div>
      <div v-if='dialogVisible'>
        <v-chart v-if='isTime' :options='options2'
                 style='width: 100%;height:60vh' ref='splashes' />
        <v-chart v-else
                 :options='options' @click='splashesClick($event)'
                 style='width: 100%;height:60vh' ref='splashes' />
      </div>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment/moment'

export default {
  name: 'fodderList',
  data(){
    return {
      input: '',
      sn: '',
      value: '',
      // timer: null,
      isTime: false,
      startTime: moment(new Date(new Date().toDateString())).format('YYYY-MM-DD'),
      endTime: moment(new Date(new Date().toDateString())).format('YYYY-MM-DD'),
      startTime2: '',
      endTime2: '',
      time: [new Date(new Date().toDateString()),new Date(new Date().toDateString())],
      buildList: [],
      apartmentList: [],
      build: '',
      apartment: '',
      total: 0,
      current: 1,
      pageSize: 10,
      dialogVisible: false,
      pickerOptions: {
        disabledDate(time) {
          let curDate = (new Date()).getTime();
          let three = 90 * 24 * 3600 * 1000;
          let threeMonths = curDate - three;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        }
      }, //只能选择三个月之前至今天的日期
      options: {
        title: {
          left: 'center',
          text: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter(params) {
            // console.log(this)
          }
        },
        grid: {
          top: '6',
          left: '0',
          right: '20',
          bottom: '3%',
          show: true,
          containLabel: true
        },
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                color: '#848484'
              }
            },
            splitNumber: 12,
            splitLine: {
              show: false
            },
            axisLabel: {// 格式化数据只显示时间的小时
              formatter: function (value, index) {
                let data = new Date(value)
                let hours = Number(data.getHours()) > 9 ?data.getHours():'0'+data.getHours()
                return hours + ':00'
              }
            },
            // type: 'category',
            type: 'time',
            data: [],
            // axisTick: {
            //   alignWithLabel: true
            // }
          }
        ],
        yAxis: [
          {
            // scale: true, //自适应
            // minInterval : 1,
            min: (value) => {
              let num = 10 ** (value.min.toString().length - 2)
              return Math.floor(value.min / num) * num;
            },
            max: (value) => {
              let num = 10 ** (value.max.toString().length - 2)
              return Math.ceil(value.max / num) * num;
            },
            axisLine: {
              lineStyle: {
                color: '#848484'
              }
            },
            type: 'value'
          }
        ],
        series: [
          {
            type: 'scatter',
            color: '#2f7ecf',
            symbolSize: 5,
            data: []
          }
        ]
      },
      options2: {
        title: {
          left: 'center',
          text: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter(params) {
            // console.log(this)
          }
        },
        grid: {
          top: '6',
          left: '0',
          right: '20',
          bottom: '3%',
          show: true,
          containLabel: true
        },
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                color: '#848484'
              }
            },
            splitLine: {
              show: false
            },
            axisLabel: {// 格式化数据只显示时间的小时
              formatter: function (value, index) {
                return value.substring(11)
              }
            },
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            // scale: true, //自适应
            // minInterval : 1,
            min: (value) => {
              let num = 10 ** (value.min.toString().length - 2)
              return Math.floor(value.min / num) * num;
            },
            max: (value) => {
              let num = 10 ** (value.max.toString().length - 2)
              return Math.ceil(value.max / num) * num;
            },
            axisLine: {
              lineStyle: {
                color: '#848484'
              }
            },
            type: 'value'
          }
        ],
        series: [
          {
            type: 'scatter',
            color: '#2f7ecf',
            symbolSize: 5,
            data: []
          }
        ]
      },
      isTimeData: [],
      tableData: [],
    }
  },
  mounted(){
    this.getPigBuildList();
    this.getApartmentList();
    this.getFodderList();
  },
  methods:{
    //获取列表数据
    getFodderList(){
      this.$http.post(this.$api.getTowerList,{
        size: this.pageSize,
        current: this.current,
        buildId: this.build,
        unitId: this.apartment,
        sn: this.input,
      }).then(res => {
        this.tableData = res.result.records;
        this.total = res.result.total;
      })
    },
    //栋舍
    getPigBuildList() {
      this.$http.post(this.$api.getPigBuildList,{
        type: 2,
        contentType: 'application/json;charset=utf-8'
      }).then(res => {
        this.buildList = res.result;
      })
    },
    syncData(){
      /*this.$alert('是否同步物联环控数据', '同步数据', {
        confirmButtonText: '确定',
        callback: action => {
          this.$http.get(this.$api.syncTower).then(res => {
            this.$message({
              type: 'success',
              message: '同步成功!'
            });
          }).catch(err =>{
            this.$message({
              type: 'error',
              message: '同步失败!'
            });
          })
        }
      });*/
      this.$confirm('是否同步物联环控数据?', '同步数据', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.get(this.$api.syncTower).then(res => {
          this.$message({
            type: 'success',
            message: '同步成功!'
          });
          this.getFodderList();
        }).catch(err =>{
          this.$message({
            type: 'error',
            message: '同步失败!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    backToday(){
      this.time = [new Date(new Date().toDateString()),new Date(new Date().toDateString())];
      this.startTime = moment(new Date(new Date().toDateString())).format('YYYY-MM-DD');
      this.endTime = moment(new Date(new Date().toDateString())).format('YYYY-MM-DD');
      this.getFindTowerData();
    },
    splashesClick(e){
      this.isTime = true;
      // this.startTimer();
      let time = this.getBeforeHalfHour(e.data[0]);
      this.isTimeData = time;
      this.getFindTowerData2(time[0],time[1]);
    },
    /**
     * 获取前半小时和后半小时
     * @param day 时间
     */
    getBeforeHalfHour(day){
      // 获取当前时间
      const now = new Date(day);

      // 获取当前时间的小时数和分钟数
      const hour = now.getHours();
      const minutes = now.getMinutes();

      // 计算当前时间的前半小时和后半小时的时间戳（单位：毫秒）
      const halfHour = 30 * 60 * 1000; // 30分钟
      const beforeHalfHour = now.getTime() - halfHour;
      const afterHalfHour = now.getTime() + halfHour;

      // 将时间戳转换成 Date 对象
      const beforeDate = moment(new Date(beforeHalfHour)).format('yyyy-MM-DD HH:mm:ss');
      const afterDate = moment(new Date(afterHalfHour)).format('yyyy-MM-DD HH:mm:ss');
      return [beforeDate,afterDate]
    },
    getFindTowerData2(startTime,endTime){
      this.startTime2 = startTime || this.startTime;
      this.endTime2 = endTime || this.endTime;
      this.$http.get(this.$api.findTowerData,{
        sn: this.sn,
        startTime,
        endTime,
      }).then(res => {
        const tip = function(params) {
          return '上报时间：' + moment(params[0].axisValue).format('YYYY-MM-DD HH:mm:ss') + '<br />' + '上报重量：' + params[0].data + ' kg'
        }
        let arr = res.result;
        this.options2.series[0].data = arr.map(item => item.data);
        this.options2.xAxis[0].data = arr.map(item => item.upTime);
        this.options2.tooltip.formatter = tip;
      })
    },
    //单元
    getApartmentList(type = '0') {
      this.$http.post(this.$api.getPigBuildList,{
        type,
        contentType: 'application/json;charset=utf-8'
      }).then(res => {
        this.apartmentList = res.result;
      })
    },
    handleEdit(index,row){
      this.dialogVisible = true;
      this.sn = row.sn;
      this.getFindTowerData();
      this.startTimer();
    },
    startTimer() {
      if (this.dialogVisible){
        // 每隔10s调用一次接口
        this.timer = setInterval(() => {
          if (this.isTime){
            this.getFindTowerData2(this.isTimeData[0],this.isTimeData[1]);
          }else {
            this.getFindTowerData();
          }
        }, 10000); // 10s，单位为毫秒
      }
    },
    selectTime(e){
      this.startTime = moment(e[0]).format('YYYY-MM-DD');
      this.endTime = moment(e[1]).format('YYYY-MM-DD');
      this.getFindTowerData();
    },
    getFindTowerData(){
      this.isTime = false;
      this.$http.get(this.$api.findTowerData,{
        sn: this.sn,
        startTime: this.startTime + ' 00:00:00',
        endTime: this.endTime + ' 23:59:59',
      }).then(res => {
        const tip = function(params) {
          return '上报时间：' + params[0].data[0] + '<br />' + '上报重量：' + params[0].data[1] + ' kg'
        };
        let arr = res.result;
        // stableValue stableTime
        this.options.series[0].data = res.result.map((item,index) =>{
          // eslint-disable-next-line no-return-assign
          return [index] = [item.upTime,item.data];
        });
        // this.options.series[0].data = arr.map(item => item.data);
        // this.options.xAxis[0].data = arr.map(item => item.upTime);
        this.options.tooltip.formatter = tip;
      })
    },
    reset(){
      this.build = '';
      this.apartment = '';
      this.input = '';
      this.getFodderList();
    },
    handleSizeChange(e){
      this.pageSize = e;
      this.getFodderList();
    },
    handleCurrentChange(e){
      this.current = e;
      this.getFodderList();
    },
    clearDialog(){
      this.dialogVisible = false;
      this.time = [new Date(new Date().toDateString()),new Date(new Date().toDateString())];
      this.startTime = moment(new Date(new Date().toDateString())).format('YYYY-MM-DD');
      this.endTime = moment(new Date(new Date().toDateString())).format('YYYY-MM-DD');
      this.stopTimer();
    },
    stopTimer() {
      // 停止定时器
      clearInterval(this.timer);
    },
    buildSelect(e){
      this.apartment = '';
      this.$http.post(this.$api.getPigBuildList,{
        type: '0',
        buildId: e,
        contentType: 'application/json;charset=utf-8'
      }).then(res => {
        this.apartmentList = res.result;
      })
    },
  },
}
</script>

<style scoped>
/deep/.table .el-table__body-wrapper{
  height: calc(100vh - 220px);
  overflow-y: auto;
}
.datePicker{
  margin-top: -70px;
  position: absolute;
  right: 60px;
}
</style>
